import type { HugeiconsProps } from '@hugeicons/react-native';
import {
  Clock01Icon as Clock01SolidIcon,
  FavouriteIcon as FavouriteSolidIcon,
  SquareLock01Icon as SquareLock01SolidIcon,
  StarIcon as StarSolidIcon,
} from '@hugeicons-pro/core-solid-rounded';
import {
  Clock01Icon,
  FavouriteIcon,
  SquareLock01Icon,
  StarIcon,
} from '@hugeicons-pro/core-stroke-rounded';
import type { TFunction } from 'i18next';

import { photoListTypes, type PhotoListType } from '~/constants/lists';

export interface IPhotoListItem {
  value: PhotoListType;
  label: string;
  icon: HugeiconsProps['icon'];
  solidIcon: HugeiconsProps['icon'];
  href: string;
}

export const photoIcons: Record<
  PhotoListType,
  [HugeiconsProps['icon'], HugeiconsProps['icon']]
> = {
  latest: [Clock01Icon, Clock01SolidIcon],
  network: [StarIcon, StarSolidIcon],
  private: [SquareLock01Icon, SquareLock01SolidIcon],
  favorites: [FavouriteIcon, FavouriteSolidIcon],
};

export function getPhotoListHref(listType: PhotoListType): string {
  return `/photos/${listType}`;
}

export function getPhotoListItems(t: TFunction): IPhotoListItem[] {
  return photoListTypes.map((listType) => {
    const [icon, solidIcon] = photoIcons[listType];

    return {
      value: listType,
      label: t(`photos.${listType}_short`),
      icon,
      solidIcon,
      href: getPhotoListHref(listType),
    };
  });
}
